<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
        <path
            d="M13.1282 14.7387C9.20653 17.0029 6.91865 17.6443 5.96561 17.7097C5.73262 17.7257 5.5328 17.5831 5.41603 17.3808L0.677244 9.17302C0.477943 8.82782 0.850983 8.43537 1.20584 8.61692L6.60358 11.3785C6.8755 11.5176 7.1967 11.3129 7.1855 11.0077L6.95593 4.75505C6.94414 4.43415 7.29622 4.23088 7.56823 4.40153L12.8684 7.72666C13.1271 7.88898 13.465 7.71314 13.4804 7.4081L13.7878 1.35275C13.808 0.954658 14.3343 0.827821 14.5337 1.17302L19.2724 9.38083C19.3892 9.58308 19.4128 9.82746 19.2825 10.0212C18.7493 10.8139 17.0499 12.4745 13.1282 14.7387Z"
            stroke="currentColor"
        />
    </svg>
</template>
